export const INITIAL_STATE = {
    navigation: {
        currentPage: null
    }
}